module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-5159cfea"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Auth.vue
// module id = 1036
// module chunks = 1